import { FindApplianceModelNumber } from './find-appliance-model-number.interface';

export interface FindBrandModelNumber {
  [key: string]: FindApplianceModelNumber[];
}
